import request from '@/utils/request'

// 获取字典类型列表
export function getDictTypeList() {
  return request({
    url: '/dict/type/list',
    method: 'get'
  })
}

// 添加字典类型
export function addDictType(data) {
  return request({
    url: '/dict/type/add',
    method: 'post',
    data
  })
}

// 更新字典类型
export function updateDictType(data) {
  return request({
    url: '/dict/type/update',
    method: 'put',
    data
  })
}

// 删除字典类型
export function deleteDictType(id) {
  return request({
    url: `/dict/type/delete/${id}`,
    method: 'delete'
  })
}

// 获取字典数据
export function getDictData(dictType) {
  return request({
    url: `/dict/${dictType}`,
    method: 'get'
  })
}

// 添加字典数据
export function addDictData(data) {
  return request({
    url: '/dict/data/add',
    method: 'post',
    data
  })
}

// 更新字典数据
export function updateDictData(data) {
  return request({
    url: '/dict/data/update',
    method: 'put',
    data
  })
}

// 删除字典数据
export function deleteDictData(id) {
  return request({
    url: `/dict/data/delete/${id}`,
    method: 'delete'
  })
} 